//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { Indicator, Toast } from 'mint-ui'
import { MessageBox } from 'mint-ui'
import { Const } from '@/consts'
import testApi from '@/api/test'
import userAPI from '@/api/user'
import examApi from '@/api/exam'
import supervisedApi from '@/api/supervised'
import ImageUtils from '@/utils/imageUtils'
import utils from '@/utils'
import slideverify from '@/components/Newcap.vue'
//import JcRange from "@/components/JcRange.vue"
// import dragVerify from "@/components/dragVerify";
import img1 from '@/assets/images/rotate1.jpg'
import img2 from '@/assets/images/rotate2.jpg'
import img3 from '@/assets/images/rotate3.jpg'
import img4 from '@/assets/images/rotate4.jpg'
export default {
  data() {
    return {
      result: {},
      compareFile: '',
      mywidth: window.innerWidth,
      compareResult: false,
      lessonid: '',
      courseid: '',
      num: 0,
      authToken: 0,
      uploading: false,
      ratios: '',
      faceShow: false,
      rangeShow: false,
      os: '',
      model: '',
      errNum: 0,
      limitLearningBySuperTimeOut: '',
      superrMsg: false,
      status: false,
      dialogopenV: false,
      puzzePass: {
        visible: false,
        block_y: 20,
        imgurl: img1,
        miniimgurl: img2,
        text: '右滑',
      }, // 滑块字段
        joinClasscode:"0"
    }
  },
  components: {
    // JcRange,
    // dragVerify,
    slideverify
  },
  created() {
    userAPI.getUserInfo().then(resp => {
      this.result = resp.result
      this.ratios = this.result.searchCode
      if (!this.result.avatarurl) {
        MessageBox({
          title: '',
          message: '您尚未上传本人近期照片,请进行资料完善',
          confirmButtonText: '进行资料完善',
          confirmButtonClass: 'button'
        }).then(action => {
          MessageBox.close()
          this.$router.push({
            path: '/personal/setting/complete',
            query: {
              from: 'course/lesson?courseid=' + this.courseid + '&lessonid=' + this.lessonid
            }
          })
        })
      }
    })
    this.lessonid = this.$route.query.lessonid
    this.courseid = this.$route.query.courseid

    let params = {
      params: {
        lessonId: this.$route.query.lessonid
      }
    }
    return supervisedApi.getLessonSupervisedInfo(params).then(resp => {
        //每次调用都会改变joinClasscode验证字符串，一旦改变下次提交数据必须更新，否则会触发人机校验接口
      this.limitLearningBySuperTimeOut = resp.result.limitLearningBySuperTimeOut / 1000
        this.joinClasscode = resp.result.joinClasscode
      this.superrMsg = true
    })
  },
  mounted() {
    // this.num = Math.floor(Math.random() * 10 + 1);
    // if (this.num > 0) {
    //   this.rangeShow = true
    //   this.faceShow = false
    // } else {
    //   this.rangeShow = false
    //   this.faceShow = true
    // }
    this.getImageVerifyCode()
  },
  methods: {
    getImageVerifyCode() {
      let _this = this
      userAPI.getImageVerifyCode().then(resp => {
        console.log(resp, "scuessscuessscuessscuessscuessscuessscuess")
        this.rangeShow = true
        this.faceShow = false
        const imgobj = {
          bigImage: 'data:image/png;base64,' + resp.result.bigImage, // 大图
          smallImage: 'data:image/png;base64,' + resp.result.smallImage, // 小图
          yHeight: resp.result.yHeight * (document.documentElement.clientWidth - 40) * 300 / 480 / 300// 初始y坐标
        }
        _this.puzzePass.block_y = imgobj.yHeight
        console.log(imgobj.yHeight, "imgobj.yHeightimgobj.yHeightimgobj.yHeight")
        _this.puzzePass.imgurl = imgobj.bigImage
        _this.puzzePass.miniimgurl = imgobj.smallImage
        _this.dialogopenV = true
        localStorage.setItem("resetBlock_y", _this.puzzePass.block_y)
        const h = Math.floor((Math.random() * 150))
        if(_this.$refs.dialogopen){
         _this.$refs.dialogopen.reset(h)
        }

        //_this.$refs.dialogopen && _this.$refs.dialogopen.reset(_this.puzzePass.block_y)
      }).catch(resp => {
        console.log(resp, "errorerrorerrorerrorerrorerrorerrorerrorerrorerrorerrorerror")
        this.rangeShow = false
        this.faceShow = true
      })
    },
    onFail() {
      console.log('fail')
    },
    // 刷新验证码
    onRefresh() {
      this.puzzePass.imgurl = ''
      this.puzzePass.miniimgurl = ''
      this.puzzePass.block_y = 0
      //this.dialogopenV=false

      this.getImageVerifyCode()
    },
    // 验证码拉动距离返回
    onSuccess(left) {
      let _this = this
      left = parseInt(left * 480 / (document.documentElement.clientWidth - 40))
      console.log('succss', left)
      userAPI.verifyImageCode("?moveLength=" + left).then(resp => {
        //_this.$refs.dialogopen.handleSuccess()
        _this.rangeShow = false
        _this.faceShow = true
        _this.authToken = resp.result
        MessageBox({
          title: '',
          message: '验证成功',
          confirmButtonText: '提示',
          confirmButtonClass: 'button'
        }).then(action => {
          _this.uploadPhoto()
        })
        //}, 5000);
        //this.$refs.upload.dispatchEvent(new MouseEvent('click'))
      }).catch(resp => {
        //_this.dialogopenV=false
        _this.$refs.dialogopen.handleFail()
        MessageBox({
          title: '',
          message: '验证失败，请重新拖动滑块验证',
          confirmButtonText: '提示',
          confirmButtonClass: 'button'
        }).then(action => {
          _this.onRefresh()
        })

      })
    },
    // errorFun() {
    //   this.showFailDialog("请拖动滑块到指定位置，请重试")
    // },
    // successFun() {
    //   MessageBox({
    //     title: '',
    //     message: '验证通过',
    //     confirmButtonText: '提示',
    //     confirmButtonClass: 'button'
    //   }).then(action => {
    //     this.rangeShow = false
    //     this.faceShow = true
    //   })
    // },
    emitChange() {
      let supervisedResult = {
        compareFile: this.compareFile,
        compareResult: this.compareResult,
        joinClasscode: this.joinClasscode
      }
      this.$emit('change', supervisedResult)
    },
    goBack() {
      this.$router.push({
        path: '/index/courseInfo',
        query: {
          lessonid: this.lessonid,
          courseid: this.courseid
        }
      })
    },

    uploadPhoto() {
      console.log(this.$refs.photoFile, "photoFilephotoFilephotoFilephotoFilephotoFilephotoFilephotoFile")
      this.$refs.photoFile.click()
      //this.$refs.photoFile.dispatchEvent(new MouseEvent('click'))
      // const trigger = () => {
      //   const $el = this.$refs.photoFile
      //   $el.dispatchEvent(new Event('click'));
      // }
      // if (!this.$refs.photoFile) {
      //   this.$nextTick(trigger.bind(this))
      // } else {
      //   trigger();
      // }
    },
    openTimeOutDialog() {
      MessageBox({
        title: '提示',
        message: '上传照片超时，点击确定返回',
        confirmButtonText: '确定',
        confirmButtonClass: 'button'
      }).then(action => {
        MessageBox.close()
        this.goBack()
      })
    },
    handlePhotoFileChange() {
      let me = this
      this.uploading = true

      const oldFile = this.$refs.photoFile.files[0]

      let ratio = 0.5
      localStorage.setItem('beforeCompressFileLength', oldFile.size)
      ImageUtils.imageProcess(oldFile, me.ratios, file => {
        if (!file) {
          localStorage.setItem('afterCompressFileLength', 'file为空')
          MessageBox({
            title: '提示',
            message: '照片处理失败，请重试',
            confirmButtonText: '确定',
            confirmButtonClass: 'button'
          }).then(action => {
            MessageBox.close()
            this.goBack()
          })
        } else if (file == 'fileErr') {
          MessageBox({
            title: '提示',
            message: '照片处理有损，请重试',
            confirmButtonText: '确定',
            confirmButtonClass: 'button'
          }).then(action => {
            MessageBox.close()
            this.goBack()
          })
        } else {
          localStorage.setItem('afterCompressFileLength', file.size)
          console.log('压缩后的尺寸为:', file.size)
          let t = setTimeout(this.openTimeOutDialog, 15000)
          // this.$refs.photoFileForm.reset();
          examApi.comparefaceReturnFile({// --
            params: {
              facepic: file,
              facepicTime: oldFile.lastModified,
              facepicSource: 'camera',
              locaTpme: new Date().getTime(),
              os: navigator.userAgent,
              model: 'this',
              authToken: me.authToken
            }
          }).then(resp => {
            clearTimeout(t)
            // localStorage.setItem("comparefaceReturnFile",file.size)
            let result = resp[Const.RESP_RESULT]
            this.compareResult = result.compareResult
            this.compareFile = result.fileResult.objectid
            if (this.compareResult === true) {
              console.log('人脸识别通过')
              utils.save('onFaceCheck' + this.lessonid + '' + this.courseid, new Date().getTime())
              this.emitChange()
            } else {
              // alert("验证不通过begin")
              // debugger
              // localStorage.setItem("验证不通过begin", resp.message)
              if (this.errNum >= 2) {
                this.errNum = 0
                MessageBox({
                  title: '提示',
                  message: '已尝试验证超过两次，请关闭美颜功能再试！',
                  confirmButtonText: '确定',
                  confirmButtonClass: 'button'
                }).then(action => {
                  MessageBox.close()
                  this.goBack()
                })
              } else {
                this.errNum = this.errNum + 1
                this.showFailDialog(resp.message)
              }
              // alert("验证不通过end")
              // localStorage.setItem("验证不通过end", resp.message)
            }
          }).catch(resp => {
            // debugger
            // alert("验证异常begin")
            // localStorage.setItem("验证异常begin", resp.message)
            clearTimeout(t)
            // localStorage.setItem("验证异常ing", resp.message)
            // localStorage.setItem("验证异常", resp.message)
            if (this.errNum >= 2) {
              this.errNum = 0
              MessageBox({
                title: '提示',
                message: '已尝试验证超过两次，请关闭美颜功能再试！',
                confirmButtonText: '确定',
                confirmButtonClass: 'button'
              }).then(action => {
                MessageBox.close()
                this.goBack()
              })
            } else {
              this.errNum = this.errNum + 1
              this.showFailDialog(resp.message)
            }
            // alert("验证异常end")
            // localStorage.setItem("验证异常end", resp.message)
          })
        }
      })
    },
    showFailDialog(message) {
      MessageBox.confirm(message + '<br/>没有通过验证,请重新验证<br/>您要继续验证吗？', '温馨提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'info'
      }).then(action => {
        this.uploading = false
        this.uploadPhoto()
      }).catch(() => {
        this.$router.push({ path: '/index/courseInfo', query: { courseid: this.$route.query.courseid } })
      })
    },

    doTest() {
      const courseId = this.courseId

      if (!courseId) {
        return
      }

      /// ///////////////////////////////////
      this.$router.push({
        path: '/exam',
        query: {
          courseId: courseId,
          examType: '1'
        }
      })
      /// ///////////////////////////////////

      // examApi.startExam({
      //     params: {
      //         courseid: courseId,
      //         examtype: 'REAL'
      //     }
      // }).then((resp) => {
      //     const result = resp[Const.RESP_RESULT];
      //     if (result === true || (result && result[Const.RESP_RESULT] === true)) {
      //         this.$router.push({path: '/exam', query: {
      //             courseId: courseId,
      //             examType: '1'
      //         }});
      //     } else {
      //         Toast('很抱歉，您暂时不能进行考试');
      //     }
      // }).catch((resp) => {
      //     // Toast(resp[Const.RESP_MESSAGE] || '出错了 ...');
      //     // this.buttonEnabled.test = true;
      //     if (resp.statusCode == '200') {
      //         Toast(resp[Const.RESP_MESSAGE] || '出错了 ...');
      //     }
      // });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/idverify4Unit.vue